// Webpack Imports
import * as bootstrap from 'bootstrap';
// import Swiper JS
import Swiper, { Pagination, EffectFade, Autoplay } from 'swiper';
// import Swiper styles


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// insert span for headline h1
	document.querySelectorAll('h1, h2').forEach(headline => {
		if((headline.clientHeight / parseInt(getComputedStyle(headline).fontSize)) > 1 ) {
			headline.classList.add('indent');
		}
		let content = headline.innerHTML;
		let wrappedcontent = '<span>'+content+'</span>';
		headline.innerHTML = wrappedcontent;
	});

	// Swiper

	const swiper = new Swiper('.swiper', {
		// configure Swiper to use modules
		modules: [Pagination, EffectFade, Autoplay],
		effect: "fade",
		fadeEffect: { crossFade: true },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		autoplay: {
			delay: 3000,
		},
		speed: 3000,
		loop: true,

	});


	// Bootstrap Nav Hover
	document.addEventListener("DOMContentLoaded", function(){
	// make it as accordion for smaller screens
			if (window.innerWidth > 992) {

				document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){

					everyitem.addEventListener('mouseover', function(e){

						let el_link = this.querySelector('a[data-bs-toggle]');

						if(el_link != null){
							let nextEl = el_link.nextElementSibling;
							el_link.classList.add('show');
							nextEl.classList.add('show');
						}

					});
					everyitem.addEventListener('mouseleave', function(e){
						let el_link = this.querySelector('a[data-bs-toggle]');

						if(el_link != null){
							let nextEl = el_link.nextElementSibling;
							el_link.classList.remove('show');
							nextEl.classList.remove('show');
						}


					})
				});

			}
	// end if innerWidth
		});
	// DOMCo
} )();
